import { SelectedError } from "../../components/main/business/model"

export const hasGenart = (list: SelectedError[], genart: string, code?: string) => {
    // eslint-disable-next-line eqeqeq
    return list.filter((y) => y.genartnr == genart && (code ? y.code == code : true)).length > 0
}
